import UserDetails from '../Common/UserDetails'

const Account = props => (
  <div className="account-page">
    <UserDetails
      username={props.user.username}
      {...props} />
  </div>
)

export default Account



// WEBPACK FOOTER //
// ./components/Account/index.js